import React, { useCallback, useContext, useEffect, useLayoutEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { FootballContext } from '../../Home/FootballPage';
import { SingleMatchTable } from '../Common/MatchTable';
import CashOutTable from '../Common/CashOutTable';
import { MatchDropdown, Remark, MatchInfo, getFoPool } from '../Common/MatchBase';
import { isLogonHigh } from '../../BetSlip/LoginHooks';
import RefreshTime from '../../Common/ui-components/RefreshTime'
import Sticky from 'react-stickynode';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { hasMatchInfoUpdate, MatchUpdateMsg } from '../Common/Common';
import { useWindowSize } from '../../Common/CommonHooks';
import getDistanceOfPageTop from '../../Common/utils/getDistanceOfPageTop';
import { FBMatchTypeTab } from '../../Common/ui-components/FBMatchTypeTab';
import { getDeviceType } from '../../Common/CommonHooks';
import { scrollTo } from '../../Common/GlobalFunc';

const ALLODDS = () => {
    const { t } = useTranslation();
    const context = useContext(FootballContext);
    const globalContext = useContext(GlobalContext);
    const [searchMatchIds,setSearchMatchIds] = useState([])
    const singleMatch = context.content.matchData.matches?.[0];
    const MatchBetTypeFilteringTab = context.content.config.MatchBetTypeFilteringTab;
    const { isMobileSize } = useWindowSize()
    const [matchTimeType, setMatchTimeType] = useState(MatchBetTypeFilteringTab?.[0]?.key)
    const [gsTab, setGsTab] = useState('GS')
    const myElementRef = useRef(null);
    useLayoutEffect(() => {
        if ( window.location.hash!='' ) {
            try{
                setTimeout(() => {
                    let typeStr = window.location.hash.substring(1).toUpperCase()
                    let match = document.querySelectorAll('section.ALLODDS > div');
                    let section = document.querySelectorAll('section.ALLODDS > section');
                    if(isMobileSize) {
                        let shiftVal = 0
                        if(document.getElementById('date-tourn-selection-sticky'))
                            shiftVal -= document.getElementById('date-tourn-selection-sticky').offsetHeight
                        if(document.getElementsByClassName('matchDropdownContainer-MatchInfoContent')?.length>0)
                             shiftVal -= document.getElementsByClassName('matchDropdownContainer-MatchInfoContent')[0].offsetHeight
                        if([...match].find((el => el.classList.contains("coupon" + typeStr)))){
                            window.scrollTo(0, getDistanceOfPageTop([...match].find((el => el.classList.contains("coupon" + typeStr))))+(shiftVal))
                        }
                        else if([...match].find((el => el.classList.contains(typeStr)))){
                            window.scrollTo(0, getDistanceOfPageTop([...match].find((el => el.classList.contains(typeStr))))+(shiftVal))
                        }
                        else if([...section].find((el => el.classList.contains("coupon" + typeStr)))){
                            window.scrollTo(0, getDistanceOfPageTop([...section].find((el => el.classList.contains("coupon" + typeStr))))+(shiftVal))
                        }
                        else if([...section].find((el => el.classList.contains(typeStr)))){
                            window.scrollTo(0, getDistanceOfPageTop([...section].find((el => el.classList.contains(typeStr))))+(shiftVal))
                        }
                    } else {
                        if([...match].find((el => el.classList.contains("coupon" + typeStr)))){
                            [...match].find((el => el.classList.contains("coupon" + typeStr))).scrollIntoView()
                        }
                        else if([...match].find((el => el.classList.contains(typeStr)))){
                            [...match].find((el => el.classList.contains(typeStr))).scrollIntoView()
                        }
                        else if([...section].find((el => el.classList.contains("coupon" + typeStr)))){
                            [...section].find((el => el.classList.contains("coupon" + typeStr))).scrollIntoView()
                        }
                        else if([...section].find((el => el.classList.contains(typeStr)))){
                            [...section].find((el => el.classList.contains(typeStr))).scrollIntoView()
                        }
                    }
                }, 2000);
            }catch (err) {
                console.error(err);
                throw err;
            }
        } else {
            // scrollTo(0, 0)
        }
    }, [window.location.hash])

    useEffect(()=>{
        if(matchTimeType ==='PLAYER'&& singleMatch?.foPools){
            let GSBetTypes = window.fbConfig.GSPools
            let GSPools = singleMatch.foPools.filter(pool => GSBetTypes.includes(pool.oddsType))
            if(GSPools.length == 1 ) {
                setGsTab(GSPools[0].oddsType)
            }
        }
    },[singleMatch?.foPools, matchTimeType, gsTab])

    useEffect(()=> {
        if(context.content.matchData.matches.length > 1){
            setSearchMatchIds(context.content.matchData.matches.map((match)=> match.id))
        }
    },[context.content.matchData.matches])


    const AllMatchTable = useCallback(({ singleMatch, matchTimeType, context, t,gsTab,setGsTab }) => {
        let AllOddsOrder = context.content.config.AllOddsOrder;
        if(matchTimeType != 'ALL'){
            const pools = MatchBetTypeFilteringTab.find(i=> i.key == matchTimeType)?.filterType
            AllOddsOrder = AllOddsOrder.filter(i => pools.includes(i))
        }
        if(hasMatchInfoUpdate(context.content)){
            return <MatchUpdateMsg />
        }
        return AllOddsOrder.map(betType => {
            let foPool = getFoPool(singleMatch, betType, null);
            if(MatchBetTypeFilteringTab?.find(i=> i.key == matchTimeType)?.excludeType?.includes(betType) ){
                return null
            }
            if(matchTimeType ==='PLAYER'){
                if(betType == 'GS' && foPool.length <= 1) return null
                let GSBetTypes = window.fbConfig.GSPools
                let GSPools = singleMatch.foPools.filter(pool => GSBetTypes.includes(pool.oddsType))
                if(GSPools.length > 1 && GSBetTypes.includes(betType)) return null
            }
            return (foPool==null ||  foPool?.length == 0) ? null : <SingleMatchTable betType={betType} match={singleMatch} foPool={foPool} key={betType} matchTimeType={matchTimeType} gsTab={gsTab} setGsTab={setGsTab}/> ;
        })
    }, [])

    const onChangeMatchTimeType = (value) =>{
        if(value != matchTimeType){
            setGsTab('GS')
        }
        setMatchTimeType(value)
        // if(value == 'ALL') return
        // const isFT = value == 'FT'
        // const curPools = isFT ? window.fbConfig.FullTimePools : window.fbConfig.FirstHalfPools
        // context.contentRef.current.oddsSelection.forEach(item =>{
        //     if(!curPools.includes(item.betType)){
        //         item.checked = false
        //     }
        // })
        // context.setContent({...context.contentRef.current})
    }

    return <>
        {singleMatch ? <>
                {context.content.pageConfig.showRefreshTime && <div className='refreshContainer'><RefreshTime product={'football'}/></div>}
        </> : null}
        <section className='ALLODDS'>
            {singleMatch ? <>
                {!context.state.windowSize.isMobileSize && <>
                    <div className='match-dropdown-container ddNoRSpace'><MatchDropdown singleMatch={singleMatch}  searchMatchIds={searchMatchIds}/></div>
                    <MatchInfo singleMatch={singleMatch} context={context}/>
                </>}
                {/*globalContext.globalState.commonCtrl.earlySettlementEnabled && isLogonHigh() && <CashOutTable match={singleMatch} /> */}
                {globalContext.globalState.commonCtrl.enableFOBetTypesFilterTab  && <FBMatchTypeTab allMatchTimeTypes={MatchBetTypeFilteringTab} selected={matchTimeType} onChange={onChangeMatchTimeType} match={singleMatch}/>}
                <AllMatchTable matchTimeType={matchTimeType} singleMatch={singleMatch}  context={context} t={t} gsTab={gsTab} setGsTab={setGsTab}/>
            </> : <MatchUpdateMsg />}
        </section>
        <div className='mobileMarginLR'>
            <Remark betType={'ALLODDS'} />
        </div>
    </>
}
export default ALLODDS;

export const AllOddsMobileMatchInfo =({state,content})=>{
    const singleMatch = content.matchData.matches?.[0];
    const searchMatchIds = content.matchData.matches.length > 1 ? content.matchData.matches.map((match)=> match.id):[]
    const contextObj={state,content};

    return <Sticky innerZ={800} top="#date-tourn-selection-sticky"  enabled={state.windowSize.isMobileSize} innerClass='matchDropdownContainer-MatchInfoContent'>
        <div className='match-dropdown-container ddNoRSpace'><MatchDropdown singleMatch={singleMatch}  searchMatchIds={searchMatchIds}/></div>
        <MatchInfo context={contextObj} singleMatch={singleMatch} />
    </Sticky>
}